import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { getCategoryDisplayItems } from '../../../redux/actions/userStaffPreferencesActions';
import { FormattedMessage } from 'react-intl';
import HelpIcon from '../../shared/HelpIcon';
import InlineHelpText from '../../shared/InlineHelpText';
import { Link } from 'react-router-dom';
import { titleText } from '../../shared/SharedInternationalizations';
import Table from '../../shared/table/Table';
import AccessControl from '../../../AccessControl';
import permissions from '../../../permissionsList';

export function UnconnectedCategoryDisplayItems(props) {
  const {
    categoryDisplay = {},
    user,
    alarmDeviceTypes,
    currentLocation,
  } = props;

  useEffect(() => {
    props.dispatch(getCategoryDisplayItems());
  }, []); //eslint-disable-line

  const [
    showCategoryDisplayHelpText,
    setShowCategoryDisplayHelpText,
  ] = useState(false);
  function toggleShowCategoryDisplayHelpText(value) {
    setShowCategoryDisplayHelpText(value);
  }
  const categoryDisplayHelpTextRef = useRef();
  const categoryDisplayHelpText = (
    <FormattedMessage
      id="userCheckinPreferences.categoryDisplayTitleHelpText"
      defaultMessage="The order of display for device categories for this user."
    />
  );

  function categoryDisplayDisplay() {
    const categories = Object.values(categoryDisplay)
      .filter((cat) => cat.username === user.username)
      .filter((cat) => alarmDeviceTypes[cat.alarm_device_type]); // Filter out deleted device types

    if (categories.length > 0) {
      const categoriesArray = categories.map((d) => {
        return {
          order: {
            sortBy: d.category_order,
            display: d.category_order + 1,
          },

          title: {
            sortBy: alarmDeviceTypes[
              d.alarm_device_type
            ].description.toUpperCase(),
            display: alarmDeviceTypes[d.alarm_device_type].description,
          },
        };
      });

      const tableHeadings = [
        {
          isSortable: false,
          display: '',
        },

        {
          isSortable: true,
          sortBy: 'title',
          display: titleText,
        },
      ];
      // generates the actual table
      const table = (
        <Table
          hasTableHead={true}
          hasSelector={false}
          tableHeadings={tableHeadings}
          selectorName="categories"
          selectorParamValue="categories"
          sortParam="order"
          tableData={categoriesArray}
          tableStyles="table__constrained table-layout__2-column"
          data-test="categories-table"
        />
      );

      return table;
    } else {
      return (
        <FormattedMessage
          id="userDisplay.defaultCategoryDisplayText"
          data-test="no-categories-text"
          defaultMessage="This user will use the default order for device categories"
          description="The check-in instructions"
        />
      );
    }
  }

  return (
    <div
      className="content-display__column"
      data-test="call-for-checkin-container">
      <div className="content-display__item-pill-container">
        <div className="item-container__main-container">
          <div className="item-container__main-text text-large text-light">
            <FormattedMessage
              id="userDisplay.categoryDisplayText"
              defaultMessage="Device Category Display Order"
              description="The check-in instructions"
            />

            <div
              className="item-container__secondary-text text-medium text-bold"
              data-test="panic-buttons-title">
              {categoryDisplayDisplay()}
            </div>
          </div>
        </div>
        <div className="item-container__info-container">
          <AccessControl
            data-test="access-control"
            feature={permissions.static.users.editUserCategoryOrder}
            userToEdit={user.id}>
            <FormattedMessage
              id="categoryDisplayItemsDisplay.userPanicButtonsEdit"
              defaultMessage="Edit Category Display Order"
              description="The check-in options"
              data-test="edit-category-display-link-text">
              {(txt) =>
                user.is_active ? (
                  <Link
                    data-test="edit-category-display-link"
                    to={`/users/${user.id}/edit/?mode=categoryEdit`}
                    state={{
                      modal: true,
                      previous: currentLocation,
                    }}
                    className="link-button button-secondary button-sm text-small">
                    {txt}
                  </Link>
                ) : (
                  ''
                )
              }
            </FormattedMessage>
          </AccessControl>
          <HelpIcon
            styles="margin-left-5"
            onClick={() => categoryDisplayHelpTextRef.current.toggleHelpText()}
            toggled={showCategoryDisplayHelpText}
          />
        </div>
      </div>
      <InlineHelpText
        ref={categoryDisplayHelpTextRef}
        toggleFunction={toggleShowCategoryDisplayHelpText}
        message={categoryDisplayHelpText}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    categoryDisplay: state.users.categoryDisplay,
    alarmDeviceTypes: state.devices.alarmDeviceTypes,
  };
};
export default connect(mapStateToProps)(UnconnectedCategoryDisplayItems);
